export const CUBE = {
  WIDTH: 1,
  DEPTH: 1,
  HEIGHT: 1,
  COLOR: 0xffffff,
};

export const SPHERE = {
  RADIUS: 0.5,
  WIDTH_SEGMENTS: 32,
  HEIGHT_SEGMENTS: 32,
  PHI_START: 0,
  PHI_LENGTH: Math.PI * 2,
  THETA_START: 0,
  THETA_LENGTH: Math.PI,
  COLOR: 0xffffff,
};

export const CYLINDER = {
  RADIUS_TOP: 0.5,
  RADIUS_BOTTOM: 0.5,
  HEIGHT: 1,
  RADIAL_SEGMENTS: 32,
  COLOR: 0xffffff,
};

export const PLANE = {
  WIDTH: 1,
  HEIGHT: 1,
  COLOR: 0xffffff,
};

export const TORUS_KNOT = {
  RADIUS: 1,
  TUBE: 0.3,
  RADIAL_SEGMENTS: 16,
  TUBULAR_SEGMENTS: 64,
  COLOR: 0xffffff,
};
const ORTHO_CAMERA_FRUSTUM_SIZE = 15;
const ORTHO_CAMERA_HALF = ORTHO_CAMERA_FRUSTUM_SIZE / 2;
export const CAMERA = {
  ORTHO_CAMERA_FRUSTUM_SIZE,
  DEFAULT_CAMERA_POSITION: { x: -4.38, y: 4.86, z: 14.04 },
  DEFAULT_CAMERA_TARGET: { x: 0, y: 0, z: 0 },
  DEFAULT_CAMERA_ZOOM: 1,
  PERSPECTIVE_CAMERA_FOV: 55,
  PERSPECTIVE_CAMERA_ASPECT: 1,
  CAMERA_NEAR: 0.01,
  CAMERA_FAR: 1000,
  DEFAULT_ORTHO_CAMERA_POSITION: { x: 0, y: 2, z: 5 },
  ORTHO_CAMERA_LEFT: -ORTHO_CAMERA_HALF,
  ORTHO_CAMERA_RIGHT: ORTHO_CAMERA_HALF,
  ORTHO_CAMERA_TOP: ORTHO_CAMERA_HALF,
  ORTHO_CAMERA_BOTTOM: -ORTHO_CAMERA_HALF,
  ORTHO_CAMERA_NEAR: 0.1,
  CAMERA_ROTATE_SPEED: 1.0,
  CAMERA_DRAGGING_SMOOTH_TIME: 0,
  CAMERA_DOLLY_SPEED: 1.0,
  CAMERA_SMOOTH_TIME: 0.25,
  CAMERA_DOLLY_TO_CURSOR: true,
  CAMERA_MIN_DISTANCE: 1,
  CAMERA_MAX_DISTANCE: 900,
  CAMERA_MIN_ZOOM: 0.1,
  CAMERA_MAX_ZOOM: 100,
};

export const FRUSTUM_LIGHT = {
  COLOR: 0x86e6ff,
  OPACITY: 0.05,
  RENDER_ORDER: 998,
  SIDE: 'DoubleSide',
  DEPTH_WRITE: false,
  DEPTH_TEST: false,
  TRIANGLES: 4,
};
